import React from 'react';
import PropTypes from 'prop-types';

import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import DepotGestionAutocomplete from 'components/Shared/DepotGestionAutocomplete';

import DropZone from 'components/Shared/DropZone';
import { ReclamationActionDetailCodes, ReclamationActionDetailType } from 'constants.js';

import stringHelper from 'utils/stringHelper';

import { MotifResolutionCodes } from 'constants.js';
import { CausePrincipaleCodes } from 'constants.js';


/* Liste des réponses possibles */
const actions = [
    "Facturation du client depuis le stock magasin",
];

// Cloture
const clotureData = {
    motifResolutionCode: MotifResolutionCodes.RegularisationFacturationClient,
    causePrincipaleCode: CausePrincipaleCodes.ErreurPreparation,
    causePrincipaleDetailId: 0,
    utilisateurFautifId: 0,
    commentaire: '',
    mailAutomatique: ''
};


class ErreurQuantiteDialogContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            articles: props.articles,
            numeroPiece: '',
            actionEffectuee: 0,
            fichiersIds: [],
            codeDepot: props.codeDepot,

            commentaire: ""
        };
    }

    componentDidMount() {
        const actionData = this.getActionData(this.state);

        this.props.onChange(actionData, clotureData);
    }

    getActionData(newState) {
        const { action } = this.props;

        if (!newState.codeDepot) {
            return null;
        }

        if (newState.actionEffectuee === null) {
            return null;
        }

        if (stringHelper.isNullOrWhitespace(newState.numeroPiece)) {
            return null;
        }

        const actionData = {
            code: action.code,
            details: [{
                code: ReclamationActionDetailCodes.Depot,
                type: ReclamationActionDetailType.CodeDepot,
                libelle: "Dépôt",
                position: 0,
                valeurString: newState.codeDepot
            },
            {
                code: ReclamationActionDetailCodes.Resultat,
                type: ReclamationActionDetailType.ChoixSimple,
                libelle: 'Action déjà effectuée vis à vis du client',
                position: 1,
                valeurString: actions[newState.actionEffectuee],
                valeurInteger: newState.actionEffectuee
            }, {
                code: ReclamationActionDetailCodes.NumeroPiece,
                type: ReclamationActionDetailType.Texte,
                libelle: 'Numéro de pièce',
                position: 2,
                valeurString: newState.numeroPiece
            }]
        };


        // Articles
        let articles = newState.articles.filter(x => x.quantiteRecue !== undefined && x.quantiteRecue !== null);
        if (articles.length === 0) {
            return null;
        }
        for (let i = 0; i < articles.length; i++) {
            actionData.details.push({
                code: ReclamationActionDetailCodes.CodeArticleQuantite,
                type: ReclamationActionDetailType.CodeArticleQuantite,
                libelle: 'Code article reçu',
                position: actionData.details.length,
                valeurInteger: articles[i].quantiteRecue,
                valeurString: articles[i].codeArticle
            });
        }


        if (newState.commentaire) {

            let detail = {
                code: ReclamationActionDetailCodes.Commentaire,
                type: ReclamationActionDetailType.Texte,
                libelle: "Commentaire",
                position: actionData.details.length,
                valeurString: newState.commentaire
            };

            actionData.details.push(detail);
        }

        if (newState.fichiersIds.length > 0) {
            actionData.fichiersIds = newState.fichiersIds;
        }

        return actionData;
    }


    handleChange = (event) => {

        let newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);

        let actionData = this.getActionData(newState);

        this.props.onChange(actionData, clotureData);
    }







    render() {
        const { articles, actionEffectuee, numeroPiece, codeDepot, commentaire } = this.state;


        return (
            <DialogContent>

                <Stack spacing={1}>

                    <>
                        <Typography variant="body1" gutterBottom>Effectuer cette action pour :</Typography>
                        <Typography variant="body2" gutterBottom>{`Générer un dossier après-vente lié affecté au groupe Qualité Entrepôt`}</Typography>
                        <Typography variant="body2" gutterBottom>{`Clôturer ce dossier après-vente`}</Typography>
                    </>


                    <DepotGestionAutocomplete
                        value={codeDepot}
                        onChange={(e, codeDepot, depot) => { this.handleChange({ target: { name: 'codeDepot', value: codeDepot } }); }}
                        label={"Dépôt"}
                        magasinsSeulement={false}
                        plateformesSeulement={false}
                        autoFocus
                        modeTri={0}
                        required={true}
                        disabled={false}
                    />

                    {articles && articles.filter(article => article.typeAnomalie !== null).map((article, index) => {
                        if (article.codeArticle !== null)
                            return (
                                <Stack key={index} direction={"row"} mt={1} spacing={1}>
                                    <TextField disabled label="Code article" value={article.codeArticle} />
                                    <TextField fullWidth disabled label="Désignation" value={article.designation} />
                                    <TextField disabled label="Quantité reçue" value={article.quantiteRecue} />
                                </Stack>
                            );
                        else
                            return null;
                    })}



                    <FormControl component="fieldset">
                        <FormLabel component="legend">Action déjà effectuée vis à vis du client:</FormLabel>
                        <RadioGroup
                            aria-label="Action effectuée"
                            name="actionEffectuee"
                            value={actionEffectuee}
                            onChange={e => this.handleChange(e)}
                        >
                            {actions.map((reponse, index) => (
                                <FormControlLabel key={index} value={index} control={<Radio />} label={reponse} />
                            ))}

                        </RadioGroup>
                    </FormControl>



                    <TextField id="numeroPiece" name="numeroPiece" label="Numéro de pièce" value={numeroPiece} onChange={this.handleChange} fullWidth required/>

                    <TextField
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Commentaire"
                        multiline
                        margin="normal"
                        value={commentaire}
                        onChange={e => this.handleChange(e)}
                    />

                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                </Stack>
            </DialogContent>
        );
    }
}

ErreurQuantiteDialogContent.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired,
    codeDepot: PropTypes.string
};

export default ErreurQuantiteDialogContent;